import Avatar, { genConfig } from 'funifier-nice-avatar'
import {useState, useEffect} from 'react'
import { BiUser } from 'react-icons/bi';
import AvatarModalEditor from './components/AvatarModalEditor'
import { fetchUser } from '../../services/auth.service'
import { useAuth } from 'contexts/Auth.context';
import { avatarDefault } from './options/avatarDefault';

interface AvatarComponentProps {
  size: number
}

export default function AvatarComponent({ size }: AvatarComponentProps) {
  const [avatarModal, setAvatarModal] = useState(false)
  const [userAvatar, setUserAvatar] = useState(null)

  const { user, refreshUser, signOut, profileUser } = useAuth();

  useEffect(() => {
    const fetchAvatar = async () => {
      const user = await fetchUser()
      setUserAvatar(user?.extra?.avatar || null)
    }
    fetchAvatar()
  }, [])
  
  const handleClose = () => {
    setAvatarModal(false)
  }

  return (
    <>
      <button
        onClick={() => {
          setAvatarModal(true)
        }}
      >
        {userAvatar ? (
          <Avatar
            style={{ width: size, height: size }}
            {...genConfig(userAvatar)}
          />
        ) : (!!user?.image?.medium?.url ? (
                    <img id="avatar" src={user?.image.medium.url} alt="" className="w-full h-full rounded-full overflow-hidden" />
                  ) : (
                    <div className="flex items-center justify-center w-full h-full p-5 rounded-full bg-gray-200">
                      <BiUser size={32} />
                    </div>
                  ))}
      </button>
      <AvatarModalEditor isOpen={avatarModal} onClose={handleClose} userAvatarObject={userAvatar ? userAvatar : avatarDefault} />
    </>
  )
}
